import request from '@/router/axios';
//查询设备点类型列表
export const searchDataFieldTypes = () => {
  return request({
    url: '/svolt-ess-boss-service/device/searchDataFieldTypes',
    method: 'get'
  })
}
//查询设备点类型列表
export const searchProductList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/searchProductList',
    method: 'get',
    params: data
  })
}
//查询设备点类型列表
export const searchDeviceLibraryTree = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/searchDeviceLibraryTree',
    method: 'post',
    data: data
  })
}
//查询设备下的点
export const searchFieldByDevice = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/searchFieldByDevice',
    method: 'get',
    params: data
  })
}
//添加设备库
export const addDeviceLibrary = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/addDeviceLibrary',
    method: 'post',
    data: data
  })
}
//查询设备库详情
export const searchDeviceLibraryDetail = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/searchDeviceLibraryDetail',
    method: 'get',
    params: data
  })
}
//修改设备库
export const updateDeviceLibrary = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/updateDeviceLibrary',
    method: 'post',
    data: data
  })
}
//删除设备库 逻辑删
export const deleteDeviceLibrary = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/deleteDeviceLibrary',
    method: 'get',
    params: data
  })
}
//添加设备点
export const addDeviceDataField = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/addDeviceDataField',
    method: 'post',
    data: data
  })
}
//修改设备点
export const updateDeviceDataField = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/updateDeviceDataField',
    method: 'post',
    data: data
  })
}
//删除设备点
export const deleteDeviceDataField = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/deleteDeviceDataField',
    method: 'get',
    params: data
  })
}
//查询设备库
export const searchDeviceLibrary = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/searchDeviceLibrary',
    method: 'post',
    data: data
  })
}
//复制设备库
export const copyDeviceLibrary = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/copyDeviceLibrary',
    method: 'post',
    data: data
  })
}
//批量绑定设备
export const batchBindDeviceLibrary = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/batchBindDeviceLibrary',
    method: 'post',
    data: data
  })
}
//Excel导入设备库
export const importDeviceLibrary = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/importDeviceLibrary',
    method: 'post',
    data: data
  })
}
//批量删除数据点
export const batchDeleteDeviceDataField = (data) => {
  return request({
    url: '/svolt-ess-boss-service/device/batchDeleteDeviceDataField',
    method: 'post',
    params: data
  })
}

export default{
  searchDataFieldTypes,
  searchProductList,
  searchDeviceLibraryTree,
  searchFieldByDevice,
  addDeviceLibrary,
  searchDeviceLibraryDetail,
  updateDeviceLibrary,
  deleteDeviceLibrary,
  addDeviceDataField,
  updateDeviceDataField,
  deleteDeviceDataField,
  searchDeviceLibrary,
  copyDeviceLibrary,
  batchBindDeviceLibrary,
  importDeviceLibrary,
  batchDeleteDeviceDataField
}



// WEBPACK FOOTER //
// ./src/api/equipmentLibrary.js